import React, {useRef} from "react";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import FiltersRenderField from "./FiltersRenderField";
import {TableColumnsWithFilter} from "./_interfaces";

interface FilterFormForColumnProps {
    column: TableColumnsWithFilter;
    values: any;
    onChange: (filterType: string, columnId: string, value: any) => void;
    onCancel: () => void;
    onApply: () => void;
    activeColumnIds: string[];
    onActiveColumnIdsChange: (ids: string[]) => void;
    filterOptions?: Record<string, any>;
}

const FilterFormForColumn = ({
                                 column,
                                 values,
                                 onChange,
                                 onCancel,
                                 onApply,
                                 activeColumnIds,
                                 onActiveColumnIdsChange,
                                 filterOptions = {}
                             } : FilterFormForColumnProps) => {
    const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const handleOnChange = (filterType: string, columnId: string, value: any) => {
        if(column.filterType === "dateRange") {
            if (!activeColumnIds.includes(column.id)) {
                onActiveColumnIdsChange([...activeColumnIds, column.id]);
            }
            onChange(filterType, columnId, value);
            if (
                Array.isArray(value) &&
                value.length === 2 &&
                value[0] !== null &&
                value[1] !== null
            ) {
                onApply();
            }
        } else {
            if (!activeColumnIds.includes(column.id)) {
                onActiveColumnIdsChange([...activeColumnIds, column.id]);
            }
            onChange(filterType, columnId, value);
            if(column.filterType === "number") {
                if (debounceTimerRef.current) {
                    clearTimeout(debounceTimerRef.current);
                }
                debounceTimerRef.current = setTimeout(() => {
                    onApply();
                }, 600);
            } else onApply();
        }
    }

    const handleReset = (filterType: string, columnId: string) => {
        if (activeColumnIds.includes(columnId)) {
            onActiveColumnIdsChange(activeColumnIds.filter(id => id !== columnId));
            onChange(filterType, columnId, "");
            onApply();
        } else {
            onCancel();
        }
    };

    return (
        <Box>
            <DialogContent sx={(theme) => ({m: 0, p: {xs:theme.spacing(0.5, 0.5, 0, 0.5), md:theme.spacing(1.5, 1.5, 1, 1.5)}, overflow: "visible"})}>
                <FiltersRenderField column={column} values={values} onChange={handleOnChange} handleReset={handleReset} filterOptions={filterOptions}/>
            </DialogContent>
        </Box>
    );
}

export default FilterFormForColumn